export const TRACK_EVENT_NAME = {
    LIVE_PAGE_WIDGET_ERROR: 'LIVE_PAGE_WIDGET_ERROR'
};
export const SELECTION_TOGGLE_FALLBACK_TIMEOUT = 30000;
export const GLOBAL_CLIENT_FETCH_TIMEOUT = 120000;
